import type { CountryCodeDropDownType } from "./residence-dropdown.types";

export const countryCodeOptions: CountryCodeDropDownType[] = [
	{ value: "DE", label: "Deutschland" },
];
